'use client';

import { useTranslations } from 'next-intl';

export function TagDescription({ tag, count }: { tag: string; count: number }) {
  const t = useTranslations('Blog.Tag');
  return (
    <p className="tag-description">
      {t('Description', {
        count,
        tag,
      })}
    </p>
  );
}

export function TagDecorator() {
  const t = useTranslations('Blog.Tag');
  return <p className="tag-decorator">{t('Label')}</p>;
}
